// extracted by mini-css-extract-plugin
module.exports = {"performanceContent":"cn_performanceContent__3-tQC","assetName":"cn_assetName__1n5Yw","title":"cn_title__11C2g","profitAmount":"cn_profitAmount__3dF9j"};